export enum PubSubEvents {
  Logout = "logout",
  AllLockedInspectionsReleased = "AllLockedInspectionsReleased",
  BeforeUnload = "beforeunload",
  InspectionReleased = "InspectionReleased",
  VideoAnalysisFinished = "VideoAnalysisFinished",
  VideoConversionFinished = "VideoConversionFinished",
  VideoSegmentationFinished = "VideoSegmentationFinished",
  DownloadingItemIsVisibleInBrowser = "DownloadingItemIsVisibleInBrowser",
  CancelLeavePage = "CancelLeavePage",
  ConfirmLeavePage = "ConfirmLeavePage",
  InspectionFileUploadFinished = "InspectionFileUploadFinished",
  OrganizationCollaborationStopped = "OrganizationCollaborationStopped",
  FeatureFlagsChanged = "FeatureFlagsChanged",
  ComparisonUpdated = "ComparisonUpdated",
}
